import {useHistory, useLocation} from 'react-router-dom';

export function useQueryParams() {
    const location = useLocation();
    const history = useHistory();
    const params = new URLSearchParams(location.search);

    const {set: _set} = params;

    const set = (key: string, value: string) => {
        _set.call(params, key, value);
        history.push({
            search: params.toString(),
        });
    };

    params.set = set;

    return params;
}
